export const ROUTE_ROOT = `/`;
export const ROUTE_DETAIL = `/watch/:slug`;
export const ROUTE_TAG_DETAIL = `/tags/:slug`;
